import script from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./svgIcon.vue?vue&type=style&index=0&id=dd26aae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd26aae2"]])

export default __exports__